import TagSectionList, { TagSectionListProps } from './TagSectionList';

export type { TagSectionListProps };
export default TagSectionList;
